import {
  ICPYDatum,
  keyByMap,
} from '../../Utils';
const getMap =
  (data: ICPYDatum[]) =>
    keyByMap<number, ICPYDatum>(({product_id}) => product_id)(data);

export default getMap;
